import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';


const workflowTestingSuiteSlice = createSlice({
  initialState,
  reducers,
  name: 'workflowTestingSuite',
});

export const {
  resetTestingSuite,
  setCreatedAtError,
  setCreatedAtFilter,
  setCurrentPage,
  setDataType,
  setDisplayVersion,
  setEvaluationTokensFilter,
  setEvaluationTokenError,
  setFilteredEvaluationsSampleSize,
  setFraudScoreFilter,
  setIsFetching,
  setIsHistoricalDataAvailable,
  setIsTestingSuiteVisible,
  setWhatIfPrerequisites,
  setNewEvalsModalConfirmed,
  setNewEvalsModalOpen,
  setVersionToTestAgainst,
  setOutcomeFilter,
  setPreviewChangesData,
  setReasonCodeFilter,
  setReviewReasonFilter,
  setSampleSizeFilter,
  setSampleTypeFilter,
  setTagsFilter,
  setWhatIfAnalysisToken,
  setWillCreateNewEvals,
  setWillCreateNewWorkflowVersion,
  setWorkflowToken,
  setWorkflowType,
  setWorkflowName,
  setVersionToTest,
  setChampionChallengerModalOpen,
  setAsOfTime,
  setTestSample,
  setSampleSize,
  setRealtimeSampleSize,
  setTotalSampleSize,
  setVersionNotes,
  setFilterParams,
  setTestName,
  setTestNotes,
  setTestToken,
  setHasTokenFormatError,
  setIsSubmittingTest,
  setAgentKey,
  setAgentTimeWindow,
  setAgentSandbox,
  setAgentLimit,
} = workflowTestingSuiteSlice.actions;

export default workflowTestingSuiteSlice.reducer;
